import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/Button';
import { Sparkles, Check, ArrowRight } from 'lucide-react';
import { motion } from 'motion/react';
import { Box, Typography, Stack, Card, Link as MuiLink } from '@mui/material';

export default function EmailVerificationSuccess() {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f8f9fa' }}>
            {/* Top Header */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                px: { xs: 3, md: 6 },
                py: 3,
                bgcolor: '#f8f9fa',
            }}>
                <Stack direction="row" alignItems="center" spacing={1} component={Link} to="/" sx={{ textDecoration: 'none' }}>
                    <Box sx={{ bgcolor: '#4f46e5', p: 0.5, borderRadius: 1.5, display: 'flex' }}>
                        <Sparkles color="white" size={24} />
                    </Box>
                    <Typography variant="h6" fontWeight={800} letterSpacing="-0.02em" sx={{ color: '#111827', fontSize: '1.2rem' }}>
                        PostPilot AI
                    </Typography>
                </Stack>

                {/* Empty Box acting as the right-side avatar placeholder shown in the mockup */}
                <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box sx={{ width: 16, height: 16, border: '2px solid #94a3b8', borderRadius: 0.5 }} />
                </Box>
            </Box>

            {/* Main Content */}
            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                <motion.div
                    initial={{ opacity: 0, scale: 0.98 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3 }}
                    style={{ width: '100%', maxWidth: 460 }}
                >
                    <Card elevation={0} sx={{ p: { xs: 4, sm: 6 }, pb: { xs: 4, sm: 5 }, borderRadius: 4, boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', border: '1px solid #e2e8f0', bgcolor: 'white', textAlign: 'center' }}>

                        <Box sx={{
                            width: 64,
                            height: 64,
                            borderRadius: '50%',
                            bgcolor: '#ecfdf5', // light green background
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 4
                        }}>
                            <Check size={32} color="#10b981" strokeWidth={3} /> {/* Emerald green check icon */}
                        </Box>

                        <Typography variant="h5" fontWeight={800} sx={{ color: '#111827', mb: 2, letterSpacing: '-0.02em' }}>
                            Email Verified Successfully!
                        </Typography>

                        <Typography variant="body1" color="#475569" sx={{ mb: 5, lineHeight: 1.6 }}>
                            Your email address has been successfully verified. You can now access all features of PostPilot AI.
                        </Typography>

                        <Button component={Link} to="/dashboard" size="lg" sx={{ width: '100%', bgcolor: '#4f46e5', color: 'white', '&:hover': { bgcolor: '#4338ca' }, py: 1.5, fontWeight: 'bold', fontSize: '1rem' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                Continue to Dashboard <ArrowRight size={18} />
                            </Box>
                        </Button>

                    </Card>
                </motion.div>
            </Box>

            {/* Footer */}
            <Box component="footer" sx={{ py: 4, textAlign: 'center' }}>
                <Typography variant="caption" fontWeight="medium" color="#94a3b8" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <span>© {new Date().getFullYear()} PostPilot AI. All rights reserved. Secure password management powered by PostPilot Systems.</span>
                </Typography>
            </Box>
        </Box>
    );
}
